import type { AISessionSseEvent } from '@/types/ai-session';

export function parseAiSessionSseEvents(chunk: string): AISessionSseEvent[] {
  return chunk
    .split(/\n\n+/)
    .map((block) => block.trim())
    .filter(Boolean)
    .map((block) => {
      const lines = block.split('\n');
      const eventLine = lines.find((line) => line.startsWith('event:'));
      // SSE 规范：同一事件块内多行 data: 需按换行合并为完整载荷
      const dataLines = lines.filter((line) => line.startsWith('data:'));
      const idLine = lines.find((line) => line.startsWith('id:'));
      const prevLine = lines.find((line) => line.startsWith('prev:'));
      const event = eventLine?.replace(/^event:\s*/, '').trim() || 'message';
      const rawData = dataLines.length
        ? dataLines
            .map((line) => line.replace(/^data:\s?/, ''))
            .join('\n')
            .trim() || '{}'
        : '{}';
      const id = idLine?.replace(/^id:\s*/, '').trim() || undefined;
      const prevId = prevLine?.replace(/^prev:\s*/, '').trim() || undefined;
      let data: Record<string, unknown> = {};
      try {
        data = JSON.parse(rawData) as Record<string, unknown>;
      } catch {
        data = { text: rawData };
      }
      if (!id) return { event, data };
      return prevId ? { event, data, id, prevId } : { event, data, id };
    });
}
